// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

//---- jQuery(UI) ----
import './src/jquery'
import 'jquery-ui/dist/jquery-ui'

//---- JavintoAppPages
require("./packs/content/content_assets")
require("./packs/content/content_pages")
require("./packs/tasks.js");
require("./packs/timeout");

require("./packs/global");
require("./packs/global_bootstrap");
require("./packs/modals");
require("./packs/stream_actions");
require("./packs/sort");

//--- DeventerSysteem
require("./src/fancybox_config");
require("./src/jquery-ui-custom");